export default "__VITE_ASSET__d40c409e__"